import React from "react"

const Header = () => {
    return (
     <div  className="ui fixed menu">
         <div className="ui container center">
             <h2>Contact Manager</h2>
         </div>

     </div>

    );
}

// className="ui fixed menu"
// className="ui container center"

export default Header;